/* Fuego & Fragancia — pestañas de la página de tienda.

   Todas las parrillas están ya en la página; al cambiar de pestaña solo se
   alterna cuál se muestra. Es instantáneo, no recarga y no pierde el scroll.

   La pestaña activa queda en la URL (?tab=...) para que compartir el enlace
   o volver atrás conserve la categoría que se estaba viendo. */

if (!customElements.get('ff-shop-tabs')) {
  customElements.define(
    'ff-shop-tabs',
    class FfShopTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.ff-shop__tab'));
        this.panels = Array.from(this.querySelectorAll('.ff-shop__panel'));
        if (!this.tabs.length) return;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab.dataset.tab, true));
        });

        // Si la URL trae una pestaña, se abre esa.
        const fromUrl = new URLSearchParams(window.location.search).get('tab');
        if (fromUrl && this.tabs.some((t) => t.dataset.tab === fromUrl)) {
          this.select(fromUrl, false);
        }
      }

      select(id, updateUrl) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.tab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          // La pestaña elegida se trae a la vista dentro de la tira.
          if (active && this.tabs.length > 3) {
            tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
          }
        });

        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.panel === id);
        });

        if (!updateUrl) return;
        // replaceState y no pushState: cambiar de pestaña no debería llenar el
        // historial de pasos que obliguen a pulsar "atrás" muchas veces.
        const url = new URL(window.location.href);
        url.searchParams.set('tab', id);
        window.history.replaceState({}, '', url);
      }
    }
  );
}
